import baseStyles from '@/Modals/BaseModal.module.css';
import localStyles from './Local.module.css';

const classes = {
  ...baseStyles,
  ...localStyles,
};

export default classes;
